import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IKBSearchResult } from "../types/KB/IKBSearchResult";


const KBSlice = createSlice({
    name: "kbDetails",
    initialState: {
        results: [] as IKBSearchResult[],
        selectKbs: [],
        previewKbId: null
    },
    reducers: {
        SetResults: (state, action: PayloadAction<IKBSearchResult[]>) => {
            state.results = action.payload;
        },
        SetPreview: (state, action: PayloadAction<number>) => {
            state.previewKbId = action.payload;
        }
    }

})

export const { SetResults } = KBSlice.actions
export default KBSlice.reducer
